import { isBefore, parseISO, format, isEqual, parse } from "date-fns"
import { navigate } from "gatsby"
import { sep } from "./constants"
import { updateUiData } from "../redux/actions"

export const combineDateAndTime = (inputDate, inputTime) => {
  if (typeof inputDate !== "undefined") {
    if (inputDate && inputTime) {
      const formattedDate = format(inputDate, "yyyy-MM-dd")
      const combinedResult = formattedDate + "T" + inputTime + ":00"

      return combinedResult
    }
  }
}

export const notFutureDatime = (inputDate, inputTime) => {
  if (inputDate && inputTime) {
    let formattedDateTime = parseISO(combineDateAndTime(inputDate, inputTime))
    return isBefore(formattedDateTime, new Date())
  }
}

export const convertStringToDecimal = amount => {
  if (amount) {
    return parseFloat(amount.toString().replace(/,/g, ""))
  }
}

export const decimalToString = maxAmount => {
  if (maxAmount) {
    // return maxAmount.toLocaleString()
    return maxAmount > 0
      ? maxAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : "0"
  } else {
    return maxAmount
  }
}

export const convertDateToString = date => {
  return format(date, "dd/MM/yyyy")
}

export const convertTextDateToDateTime = value => {
  return parse(value, `d${sep}M${sep}yyyy`, new Date()).setHours(0, 0, 0, 0)
}

export const isAfterDateTime = (startDate, startTime, endDate, endTime) => {
  if (startDate && startTime.length === 5 && endDate && endTime.length === 5) {
    let startDateTime = parseISO(combineDateAndTime(startDate, startTime))
    let endDateTime = parseISO(combineDateAndTime(endDate, endTime))

    return (
      isBefore(startDateTime, endDateTime) ||
      isEqual(startDateTime, endDateTime)
    )
  }
}

export const dateFormat = val => {
  let date = limit(val.substring(0, 2))
  let month = limit(val.substring(2, 4))
  let year = yearLimit(val.substring(4, 8))

  return date + (month.length ? "/" + month : "") + "/" + year
}

const limit = (val, max) => {
  if (val.length === 2) {
    //this can happen when user paste number
    if (val > max) {
      val = max
    } else if (Number(val) === 0) {
      val = "01"
    }
  }
  return val
}

const yearLimit = val => {
  const minYear = 1900
  const maxYear = 2099

  if (val.length === 4) {
    //this can happen when user paste number
    if (val > maxYear) {
      val = maxYear
    } else if (val < minYear) {
      val = minYear
    }
  }
  return val
}

export const updateUiCurrentPageNumber = (dispatch, pathName) => {
  let pageNumber

  if (pathName.includes("petDetail")) pageNumber = 2
  else if (pathName.includes("benefitsMainMenu")) pageNumber = 3
  else if (pathName.includes("petLoss")) pageNumber = 4
  else if (pathName.includes("supportingDocument")) pageNumber = 5
  else if (pathName.includes("reviewClaim")) pageNumber = 6
  else if (pathName.includes("submittedClaim")) pageNumber = 7
  else pageNumber = 1

  dispatch(updateUiData("pageNumber", pageNumber))
}

export const backMaxPage = maxPage => {
  switch (maxPage) {
    case 1:
      navigateToIndex()
      break
    case 2:
      navigateToPetDetail()
      break
    case 3:
      navigateToBenefits()
      break
    case 4:
      navigateToPetLoss()
      break
    case 5:
      navigateToSupportingDocument()
      break
    case 6:
      navigateToSubmittedClaim()
      break
    case 7:
      navigateToSubmittedClaim()
      break
    default:
      break
  }
}

export const navigateToIndex = () => {
  navigate("/")
}
export const navigateToPetDetail = () => {
  navigate("/petDetail")
}
export const navigateToBenefits = () => {
  navigate("/benefitsMainMenu")
}
export const navigateToPetLoss = () => {
  navigate("/petLoss")
}
export const navigateToSupportingDocument = () => {
  navigate("/supportingDocument")
}
export const navigateToReviewClaim = () => {
  navigate("/reviewClaim")
}
export const navigateToSubmittedClaim = () => {
  navigate("/submittedClaim")
}
export const navigateToCheckPoint = () => {
  navigate("/checkPoint")
}
export const navigateToError = () => {
  navigate("/errorOccurred")
}
